/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 23/05/2025 - 01:16:37
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 23/05/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Card, Button } from "react-bootstrap";
import Navbar from "../../components/shared/navbar";
import Footer from "../../components/shared/footer";
import { auth } from "../../firebase";

const AnalysisPaymentSuccess: React.FC = () => {
  const location = useLocation();
  const paymentData = location.state;
  const user = auth.currentUser;
  const [countdown, setCountdown] = useState<number>(10);

  useEffect(() => {
    // Clean up any stored client secrets
    localStorage.removeItem("analysisClientSecret");
    localStorage.removeItem("stripeClientSecret");
    
    // Set up redirect timer
    const redirectTimeout = setTimeout(() => {
      window.location.href = "https://pv-glarecheck.com/thank-you";
    }, 5000);
    
    // Set up countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown(prevCount => {
        if (prevCount <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prevCount - 1;
      });
    }, 500);
    
    // Clean up timers on component unmount
    return () => {
      clearTimeout(redirectTimeout);
      clearInterval(countdownInterval);
    };
  }, []);

  return (
    <React.Fragment>
      <Navbar />
      <div className="container mt-5 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <Card className="shadow-lg">
              <Card.Body className="text-center p-5">
                {/* Success Icon */}
                <div className="mb-4">
                  <div 
                    className="rounded-circle bg-success d-inline-flex align-items-center justify-content-center"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <svg 
                      width="40" 
                      height="40" 
                      fill="white" 
                      viewBox="0 0 24 24"
                    >
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                  </div>
                </div>

                {/* Success Message */}
                <h2 className="text-success mb-3">Payment Successful!</h2>
                <h5 className="mb-4">Analysis as a Service Order Completed</h5>
                
                {/* Redirect Notice */}
                {/* <div className="alert alert-info mb-4">
                  <small>You will be redirected to our thank you page in <strong>{countdown}</strong> seconds...</small>
                </div> */}
                
                {/* Order Details */}
                <div className="bg-light p-4 rounded mb-4">
                  <div className="row text-start">
                    <div className="col-6">
                      <strong>Service:</strong>
                    </div>
                    <div className="col-6">
                      Professional Analysis
                    </div>
                  </div>
                  
                  {paymentData?.orderId && (
                    <div className="row text-start mt-2">
                      <div className="col-6">
                        <strong>Order ID:</strong>
                      </div>
                      <div className="col-6">
                        {paymentData.orderId}
                      </div>
                    </div>
                  )}
                  
                  <div className="row text-start mt-2">
                    <div className="col-6">
                      <strong>Amount Paid:</strong>
                    </div>
                    <div className="col-6">
                      {paymentData?.amount ? `€${paymentData.amount}` : "€199.00"}
                    </div>
                  </div>
                  
                  {paymentData?.voucherApplied && (
                    <div className="row text-start mt-2">
                      <div className="col-6">
                        <strong>Voucher Applied:</strong>
                      </div>
                      <div className="col-6 text-success">
                        {paymentData.voucherApplied}
                      </div>
                    </div>
                  )}
                  
                  <div className="row text-start mt-2">
                    <div className="col-6">
                      <strong>Email:</strong>
                    </div>
                    <div className="col-6">
                      {user?.email}
                    </div>
                  </div>
                </div>

                {/* What Happens Next */}
                <div className="text-start mb-4">
                  <h6 className="text-primary mb-3">What happens next?</h6>
                  <ul className="list-unstyled">
                    <li className="mb-2">
                      <span className="text-success me-2">✓</span>
                      Your analysis order has been received
                    </li>
                    <li className="mb-2">
                      <span className="text-success me-2">✓</span>
                      You will receive a confirmation email shortly
                    </li>
                    <li className="mb-2">
                      <span className="text-primary me-2">⏳</span>
                      Our experts will begin processing your analysis
                    </li>
                    <li className="mb-2">
                      <span className="text-primary me-2">📧</span>
                      We will get in touch with you via email to discuss your project details
                    </li>
                    <li className="mb-2">
                      <span className="text-primary me-2">📊</span>
                      You'll receive your detailed report.
                    </li>
                  </ul>
                </div>

                {/* Action Buttons */}
                {/* <div className="d-grid gap-2">
                  <Link to="/dashboard" className="btn btn-primary btn-lg">
                    Back to Dashboard
                  </Link>
                  <a 
                    href="https://pv-glarecheck.com/thank-you" 
                    className="btn btn-outline-secondary"
                  >
                    Go to Thank You Page Now
                  </a>
                </div> */}

                {/* Contact Support */}
                <div className="mt-4 pt-4 border-top">
                  <p className="text-muted small mb-0">
                    Questions about your order? 
                    <a href="mailto:support@pv-glarecheck.com" className="text-decoration-none ms-1">
                      Contact Support
                    </a>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default AnalysisPaymentSuccess;